module.exports = __webpack_public_path__ + "images/file_icons_v2/cpp-09c7c80b4649e8d208cad91ce4d57298.svg";